
import Vue, { PropType } from 'vue';
import { mapState } from 'vuex';
import { convertDateToAmericanFormat, formatNumber } from '../../lib/utils';

export default Vue.extend({
    props: {
        data: {
            type: Array as PropType<object>,
        },
        loading: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        ...mapState('texts', ['sustainabilityReport']),
        headers(): any {
            const newHeaders = [
                { text: 'Date', value: 'date' },
                { text: 'Route', value: 'routeName' },
                { text: this.sustainabilityReport.numberOfTickets, value: 'boardedPassengers' },
                { text: 'Mileage', value: 'mileage' },
                { text: 'Gallons of Fuel Used', value: 'fuelUsed' },
                { text: 'CO2 (Lbs)', value: 'co2' },
                { text: 'Other GHG (Lbs)', value: 'otherGhg' },
                { text: 'Total GHG (Lbs)', value: 'totalGhg' },
            ];
            return newHeaders;
        },
    },
    methods: {
        convertDateToAmericanFormat,
        formatNumber,
    },
    data() {
        return {
        };
    },
});
